import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-product-master',
  templateUrl: './product-master.component.html',
  styleUrls: ['./product-master.component.scss']
})
export class ProductMasterComponent implements OnInit {

  isProcessing = true;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  _temp: any = {};
  columnLists: any = {};
  productMasterDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.productMasterDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.productMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    console.log(this.columnLists);
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        console.log(error);

      }
    })
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  productMasterDataForTable1Temp: any;
  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.productMasterDataForTable1Temp.length > 0) {
      this.pager = this.paginationService.getPager(this.productMasterDataForTable1Temp.length, page, this.perPage, targetpage);
      this.pagedItems = this.productMasterDataForTable1Temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  getcallMethod() {
    this.productMasterDataForGrid = [];
    setTimeout(() => {
      this.isProcessing = false
    }, 3000);
    const data = {

      gridName: "PRODUCTS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_PRODUCT_MASTER_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.productMasterDataForGrid = response1;
            this.visibleAuditTrail = false;
            console.log('Data - ', this.productMasterDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const row of this.productMasterDataForGrid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    row[element.columnName] = row[element.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
            });
            this.message.gridList = this.productMasterDataForGrid;
            this.collectionSize = this.productMasterDataForGrid.length;
            this.totalPages = Math.ceil(this.productMasterDataForGrid.length / this.itemsPerPage);
            this.labelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  qmsProductMasterVwDetails: any = [];
  ngOnInit() {
    this.isProcessing = true;
    this.getcallMethod();
    this.appService.getQmsProductMasterVwDetails().subscribe((response: any) => {
      this.qmsProductMasterVwDetails = response
      this.isProcessing = false;
    })
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.productMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.productMasterDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.productMasterDataForTable1Temp = this.productMasterDataForGrid;
      this.pager = this.paginationService.getPager(this.productMasterDataForTable1Temp.length, 1, this.perPage, 0);
      this.pagedItems = this.productMasterDataForTable1Temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.productMasterDataForGrid == undefined) {
        return this.productMasterDataForGrid;
      }
      if (!this.productMasterDataForGrid.length) {
        return this.productMasterDataForGrid;
      }
      if (filter) {
        this.productMasterDataForTable1Temp = this.productMasterDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.productMasterDataForTable1Temp = this.productMasterDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }

      this.setPagedorserch(1, 0);
    }
  }


  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.productMasterDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(list: any) {
    console.log(list);
    let productName = list.target.innerText;
    let filtedProductMasterDatum = this.productMasterDataForGrid.find((x: any) => x.PRODUCT_NAME === productName);
    this.message.productIdFromProductMaster = filtedProductMasterDatum.PRODUCT_ID;
    this.router.navigate(['dashboard/productCountries']);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.productMasterDataForGrid) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.productMasterDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.productMasterDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.PRODUCT_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.productMasterDataForGrid.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  productMasterFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Product Master";
    this.productMasterFieldData.productName = '';
    this.productMasterFieldData.productDescription = '';
    this.productMasterFieldData.genericName = '';
    this.productMasterFieldData.productShortName = '';
    this.productMasterFieldData.whoddName = '';
    this.productMasterFieldData.productType = '';
    this.productMasterFieldData.productTherapeuticGrp = '';
    this.productMasterFieldData.formulation = '';
    this.productMasterFieldData.strength = '';
    this.productMasterFieldData.unit = '';
    this.productMasterFieldData.packSize = '';
    this.productMasterFieldData.comments = '';
    this.productMasterFieldData.ndc = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataProductId: any;
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Product Master";
    this.previousDataProductId = editRowData.PRODUCT_ID;
    this.appService.getQmsProductMasterVwDetailsByProductId(editRowData.PRODUCT_ID).subscribe((response: any) => {
      this.qmsProductMasterVwDetails = response
      this.productMasterFieldData.productId = this.qmsProductMasterVwDetails.productId;
      this.productMasterFieldData.productName = this.qmsProductMasterVwDetails.productName;
      this.productMasterFieldData.productDescription = this.qmsProductMasterVwDetails.productDescription;
      this.productMasterFieldData.genericName = this.qmsProductMasterVwDetails.genericName;
      this.productMasterFieldData.productShortName = this.qmsProductMasterVwDetails.productShortName;
      this.productMasterFieldData.reasonForSignature = this.qmsProductMasterVwDetails.reasonForSignature;
      this.productMasterFieldData.whoddName = this.qmsProductMasterVwDetails.whoddName;
      this.productMasterFieldData.productType = this.qmsProductMasterVwDetails.productType;
      this.productMasterFieldData.productTherapeuticGrp = this.qmsProductMasterVwDetails.productTherapeuticGrp;
      this.productMasterFieldData.formulation = this.qmsProductMasterVwDetails.formulation;
      this.productMasterFieldData.strength = this.qmsProductMasterVwDetails.strength;
      this.productMasterFieldData.unit = this.qmsProductMasterVwDetails.unit;
      this.productMasterFieldData.packSize = this.qmsProductMasterVwDetails.packSize;
      this.productMasterFieldData.comments = this.qmsProductMasterVwDetails.comments;
      this.productMasterFieldData.ndc = this.qmsProductMasterVwDetails.ndc;
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  addAndEditFunction(productMasterFieldData: any) {
    this.isProcessing = true;

    // Reset previous error styles
    const productNameElement = document.getElementById('product-name-validation') as HTMLInputElement;
    if (productNameElement) {
      productNameElement.style.color = '';
    }

    const commentsElement = document.getElementById('updateReason') as HTMLTextAreaElement;
    if (commentsElement) {
      commentsElement.style.borderColor = '';
    }

    // Always validate product name
    if (!productMasterFieldData.productName?.trim()) {
      if (productNameElement) {
        productNameElement.style.color = 'red';
      }
      this.snackBar.open('Product Name is required.', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['Error']
      });
      this.isProcessing = false;
      return;
    }

    // Validate comments ONLY if the field is visible (i.e., visibleEditButton is true)
    if (this.visibleEditButton) {
      if (!productMasterFieldData.comments?.trim()) {
        if (commentsElement) {
          commentsElement.style.borderColor = 'red';
          commentsElement.focus();
        }

        this.snackBar.open('Update Reason is required.', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['Error']
        });

        this.isProcessing = false;
        return;
      }
    }

    // Proceed based on operation type
    if (this.operationFlag === 'ADD') {
      // Set common fields
      this.appService.createQmsProductMaster(productMasterFieldData).subscribe({
        next:
          (response: any) => {
            this.displayMessage = response.result;
            this.displayResultType = response.resultType;

            if (response.resultType === 'S') {
              this.visibleAddAndEditPopup.close();
              this.ngOnInit();
            }

            const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: response.result,
                type: response.resultType === 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok'
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: response.resultType === 'S' ? 'Success' : 'Error'
            });

            sb.onAction().subscribe(() => {
              sb.dismiss();
            });

            this.isProcessing = false;
          }, error:
          (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            console.error('Create Product Error:', error);
            throw error;
          }
      }
      );
    } else {
      // EDIT operation
      delete productMasterFieldData.createdOn;
      delete productMasterFieldData.updatedOn;
      productMasterFieldData.productId = this.previousData.PRODUCT_ID;
      this.appService.updateQmsProductMaster(productMasterFieldData).subscribe({
        next:
          (response: any) => {
            this.displayMessage = response.result;
            this.displayResultType = response.resultType;

            if (response.resultType === 'S') {
              this.visibleAddAndEditPopup.close();
              this.ngOnInit();
            }

            const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: response.result,
                type: response.resultType === 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok'
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: response.resultType === 'S' ? 'Success' : 'Error'
            });

            sb.onAction().subscribe(() => {
              sb.dismiss();
            });

            this.isProcessing = false;
          }, error:
          (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            console.error('Update Product Error:', error);
            throw error;
          }
      }
      );
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deletePproductMasterProductId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Product Master";
    this.deletePproductMasterProductId = deleteRowData.PRODUCT_ID;
    if (this.productMasterFieldData.deleteReason != undefined) {
      this.productMasterFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {
        productId: this.deletePproductMasterProductId,
        productName: this.productMasterFieldData.productName,
        deleteReason: this.productMasterFieldData.deleteReason,
      }
      this.appService.deleteQmsProductMaster(data).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, product: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : product.PRODUCT_ID;
    this.auditTrail.gridName = 'PRODUCTS';
    this.auditTrail.report_And_Popup_Name = 'Product Master Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(product);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Product Master Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  labelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
}
